export default __webpack_public_path__ + "pgnv-assets/62ac3e2b4cc35e0db5e681bd6c5252b4.png";